import { render, staticRenderFns } from "./ReportItemsOnBackorder.vue?vue&type=template&id=15d302ca"
import script from "./ReportItemsOnBackorder.vue?vue&type=script&lang=js"
export * from "./ReportItemsOnBackorder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../ClientApp/wwwroot/dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports